import { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
  InputAdornment,
  Switch,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";

//Icons
import SearchIcon from "@mui/icons-material/Search";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
//Srcs
import "../Style/pagestyle.scss";
import FooterPagination from "../Components/Include/FooterPagination";
import LoadingPage from "../Components/Include/LoadingPage";
import { GET_GROUP_PAGINATION, UPDATE_GROUP_IS_USE, UPDATE_GROUP_SORT_ORDER } from "../Schema/Group";
import EmptyData from "../Components/Include/EmptyData";
import CreateIcon from "../Assets/create-icon.svg";
import CreateGroup from "../Components/Group/CreateGroup";
import GroupAction from "../Components/Group/GroupAction";
import { AuthContext } from "../Context/AuthContext";

export default function Size() {
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [pagination, setPagination] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [draggedIndex, setDraggedIndex] = useState(null);

  // Switch
  const [status, setStatus] = useState("All");

  const [tableData, setTableData] = useState([]);
  const { refetch } = useQuery(GET_GROUP_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      pagination,
      keyword: keyword,
      isUse: status === "All" ? null : status,
    },
    onCompleted: ({ getGroupPagination }) => {
      setTableData(getGroupPagination?.data);
      setPaginationData(getGroupPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  const [updateGroupIsUse] = useMutation(UPDATE_GROUP_IS_USE, {
    onCompleted: ({ updateGroupIsUse }) => {
      if (updateGroupIsUse?.status) {
        setAlert(true, "success", updateGroupIsUse?.message);
        refetch();
      } else {
        setAlert(true, "error", updateGroupIsUse?.message);
      }
    },
    onError: (error) => {
      setAlert(true, "error", error?.message);
    },
  });

  const handleUpdateStatus = (id, status) => {
    updateGroupIsUse({
      variables: {
        id: id,
        isUse: status,
      },
    });
  };

  const [updateGroupSortOrder] = useMutation(UPDATE_GROUP_SORT_ORDER, {
    onCompleted: ({ updateGroupSortOrder }) => {
      setLoading(false);
      // console.log("updateGroupSortOrder::", updateGroupSortOrder);
      if (updateGroupSortOrder?.status) {
        // setAlert(true, "success", updateGroupSortOrder?.message);
        refetch();
      } else {
        console.log("updateGroupSortOrder::", updateGroupSortOrder);
        // setAlert(true, "error", updateGroupSortOrder?.message);
      }
    },
    onError: (error) => {
      console.log("error:: updateGroupSortOrder::", error);
      setLoading(false);
      // setAlert(true, "error", error?.message);
    },
  });


  const handleDragStart = (index, e) => {
    setDraggedIndex(index);
  };

  const handleDragOver = (e) => {
    e.preventDefault(); // allow drop
  };

  const handleDrop = async (dropIndex) => {
    if (draggedIndex === null) return

    // Reorder array locally
    const newTableData = [...tableData];
    const [moved] = newTableData.splice(draggedIndex, 1);
    newTableData.splice(dropIndex, 0, moved);

    // Calculate new sortOrder using gap method
    const prev = dropIndex > 0 ? newTableData[dropIndex - 1] : null;
    const next = dropIndex < newTableData.length - 1 ? newTableData[dropIndex + 1] : null;

    let newSortOrder;
    if (prev && next) newSortOrder = (prev.sortOrder + next.sortOrder) / 2;
    else if (prev && !next) newSortOrder = prev.sortOrder + 10;
    else if (!prev && next) newSortOrder = next.sortOrder / 2;
    else newSortOrder = 10;

    // Update state
    setTableData(newTableData);
    setDraggedIndex(null);

    // ✅ Only send to backend if sortOrder actually changed
    if (moved.sortOrder !== newSortOrder) {
      const updatedMoved = { ...moved, sortOrder: newSortOrder };
      console.log(updatedMoved)
      await updateGroupSortOrder({
        variables: {
          id: updatedMoved._id,
          input: {
            sortOrder: updatedMoved.sortOrder
          }
        }
      });
    }
  };


  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="/setting">
            <Typography className="page-title">ការកំណត់</Typography>
          </Link>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="slash-title">/</Typography>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">ក្រុម</Typography>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={3} md={3} lg={3} xl={2.4}>
            <Typography className="header-text">ស្វែងរក</Typography>
            <TextField
              placeholder="ស្វែងរកឈ្មោះអ្នកប្រើប្រាស់"
              size="small"
              className="search-field"
              onChange={(e) => setKeyword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "black" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6} sm={3} md={3} lg={3} xl={2.4}>
            <Typography className="header-text">ស្ថានភាព</Typography>
            <FormControl className="search-field" fullWidth size="small">
              <Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value="All">ទាំងអស់</MenuItem>
                <MenuItem value={true}>ប្រើប្រាស់</MenuItem>
                <MenuItem value={false}>មិនប្រើប្រាស់</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={3} md={3} lg={3} xl={2.4}>
            <Typography className="header-text">រៀបតាមលំដាប់</Typography>
            <Switch
              checked={!pagination}
              onChange={() => setPagination(prev => !prev)}
            />
          </Grid>

          <Grid item xs={6} sm={3} md={3} lg={3} xl={4.8}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                បង្កើត
              </Button>
            </Stack>
            {
              open && (
                <CreateGroup
                  open={open}
                  handleClose={handleClose}
                  setRefetch={refetch}
                />
              )
            }
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                {
                  !pagination && <TableCell className="header-title-start" />
                }
                <TableCell className={pagination ? "header-title-start" : 'header-title'} width="10%">
                  ល.រ
                </TableCell>
                <TableCell className="header-title" width="15%">
                  ក្រុមជាភាសាខ្មែរ
                </TableCell>
                <TableCell className="header-title" width="15%">
                  ក្រុមជាអង់គ្លេស
                </TableCell>
                <TableCell className="header-title" width="20%">
                  Remark
                </TableCell>
                <TableCell className="header-title" align="center" width="10%">
                  Status
                </TableCell>

                <TableCell className="header-title-end" width="30%"></TableCell>
              </TableRow>
            </TableHead>

            {loading ? (
              <LoadingPage colSpan={7} />
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <EmptyData colSpan={7} />
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow
                          className="body-row"
                          // className={`body-row ${draggedIndex === index ? "dragging" : ""}`}
                          key={index}
                          draggable
                          onDragStart={!pagination ? (e) => handleDragStart(index, e) : () => { }}
                          onDragOver={!pagination ? handleDragOver : () => { }}
                          onDrop={!pagination ? () => handleDrop(index) : () => { }}
                          sx={{
                            opacity: draggedIndex === index ? 0.5 : 1,
                            backgroundColor: draggedIndex === index ? "#e6f7ff" : "inherit",
                            cursor: "move",
                          }}
                        >
                          {
                            !pagination && (
                              <TableCell className="body-cell-start" align="center" >
                                <DragIndicatorIcon
                                  sx={{
                                    color: "#0f81c2",
                                    fontSize: "22px",
                                  }}
                                />
                              </TableCell>
                            )
                          }
                          <TableCell className={pagination ? "body-cell-start" : 'body-cell'}>
                            {index + 1}
                          </TableCell>

                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {row?.groupKhName}
                            </Typography>
                          </TableCell>
                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {row?.groupEnName}
                            </Typography>
                          </TableCell>

                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {row?.remark}
                            </Typography>
                          </TableCell>
                          <TableCell className="body-cell" align="center">
                            <Box>
                              <Switch
                                checked={row?.isUse}
                                onChange={() =>
                                  handleUpdateStatus(row?._id, !row?.isUse)
                                }
                              />
                            </Box>
                          </TableCell>
                          <TableCell className="body-cell-end" align="right">
                            <GroupAction editData={row} setRefetch={refetch} />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        {
          pagination && tableData?.length > 0 && (
            <FooterPagination
              totalPages={paginationData?.totalPages}
              totalDocs={paginationData?.totalDocs}
              limit={limit}
              page={page}
              setPage={setPage}
              handleLimit={handleLimit}
            />
          )
        }
      </Box>
    </div>
  );
}
